import { StringValidation } from '../../../../../utils/component-validations';
import FlexRow from '../../../layout/flex/row.gjs';
import Super from '../../../core/label.gjs';

export default class SpdsInputDropdownListLabel extends Super {
  arguments = [new StringValidation({ optional: ['label'] })];
  baseClass = 'spds-input-dropdown-list-label';

  <template>
    <FlexRow
      class={{this.classes}}
      data-test-spds-input-dropdown-list-label
      id={{this.id}}
      ...attributes
      {{this.validateArguments}}
    >
      {{#if @label}}
        {{@label}}
      {{else}}
        {{yield}}
      {{/if}}
    </FlexRow>
  </template>
}
